export default "__VITE_ASSET__e837aff3__"